import { Reducer } from 'redux';
import {
  PromoCodesState,
  GET_PROMO_CODES_LIST,
  PromoCodeActionTypes,
  GET_PROMO_CODE,
  POST_PROMO_CODE,
  PUT_PROMO_CODE,
  DELETE_PROMO_CODE,
  UPDATE_PROMO_CODE_FILTERS
} from '../types/promocode.types';

const initialState: PromoCodesState = {
  promoCodes: [],
  selectedPromoCode: null,
  postSuccess: null,
  lastFetch: null,
  totalPages: 1,
  totalElements: 0,
  filters: null
};

export const promoCodesReducer: Reducer<PromoCodesState> = (
  state: PromoCodesState = initialState, action
) => {
  const timeOfAction = new Date().getTime();
  switch ((action as PromoCodeActionTypes).type) {
    case GET_PROMO_CODES_LIST:
      return {
        ...state,
        promoCodes: action.payload.page.content,
        selectedPromoCode: null,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalElements: action.payload.page.totalElements,
        totalPages: action.payload.page.totalPages
      };
    case GET_PROMO_CODE:
      return {
        ...state,
        postSuccess: null,
        selectedPromoCode: action.payload.selectedPromoCode,
        lastFetch: timeOfAction
      };
    case POST_PROMO_CODE:
      return {
        ...state,
        postSuccess: true,
        selectedPromoCode: action.payload.newPromoCode,
        lastFetch: timeOfAction
      };
    case PUT_PROMO_CODE:
      return {
        ...state,
        selectedPromoCode: action.payload.selectedPromoCode,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_PROMO_CODE:
      return {
        ...state,
        selectedPromoCode: null,
        lastFetch: timeOfAction
      };
    case UPDATE_PROMO_CODE_FILTERS:
      return {
        ...state,
        filters: action.payload.filters
      };
    default:
      return state;
  }
};
